import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TerraIconModule, TerraSearchInputComponent, TerraSearchInputModule } from '@ninety/terra';

@Component({
  selector: 'ninety-team-search',
  templateUrl: './team-search.component.html',
  styleUrls: ['./team-search.component.scss'],
  standalone: true,
  imports: [TerraIconModule, TerraSearchInputModule, FormsModule],
})
export class TeamSearchComponent {
  @Output() searchChanged = new EventEmitter<string>();

  @ViewChild(TerraSearchInputComponent) searchInput?: TerraSearchInputComponent;

  protected _searchTerm = '';

  protected onSearchChange(searchStr: string) {
    this._searchTerm = searchStr;
    this.searchChanged.emit(searchStr);
  }

  protected clearSearch() {
    this._searchTerm = '';
    this.searchChanged.emit('');
  }

  public focus(): void {
    this.searchInput?.focus();
  }
}
